import { apiFetch } from '../api/client'

export type ClientEventKind = 'page' | 'journey' | 'error' | 'save' | 'release'
export type ClientSurface = 'app' | 'auth' | 'prof' | 'progressi' | 'simula' | 'appendice' | 'messaggi' | 'profilo' | 'lezione' | 'pwa'
export type ClientEventOutcome = 'started' | 'visible' | 'success' | 'failure' | 'cancelled'
export type ClientEventCode =
  | 'route_visible'
  | 'render_boundary'
  | 'invite_completed'
  | 'registration_completed'
  | 'login_completed'
  | 'exam_result_saved'
  | 'exam_result_save_failed'

export interface ClientProductEvent {
  eventKind: ClientEventKind
  surface: ClientSurface
  outcome: ClientEventOutcome
  /** Stable machine code only. Never pass user copy, prompts, or exception text. */
  code: ClientEventCode
}

export function surfaceForPath(pathname: string): ClientSurface {
  if (pathname.startsWith('/profilo')) return 'profilo'
  if (pathname.startsWith('/prof')) return 'prof'
  if (pathname.startsWith('/progresso')) return 'progressi'
  if (pathname.startsWith('/simula')) return 'simula'
  if (pathname.startsWith('/appendice')) return 'appendice'
  if (pathname.startsWith('/messaggi')) return 'messaggi'
  if (pathname.startsWith('/lezione') || pathname.startsWith('/studia/argomento')) return 'lezione'
  return 'app'
}

type EventSender = typeof apiFetch

export function trackClientEvent(event: ClientProductEvent, send?: EventSender): Promise<void> {
  try {
    const sender = send ?? apiFetch
    const request = sender('/api/client-events', {
      method: 'POST',
      keepalive: true,
      body: JSON.stringify({
        ...event,
        occurredAt: new Date().toISOString(),
      }),
    })
    // Promise.resolve also tolerates lightweight test/native adapters that do
    // not return a fetch promise, while production apiFetch always does.
    return Promise.resolve(request).then(() => undefined, () => undefined)
  } catch {
    return Promise.resolve()
  }
}
